import type { intlFormatPropTypes } from "react-intl";
import { z } from "zod";

type BuildSpaceRulesSchemaArgs = {
  intl: intlFormatPropTypes;
};

const buildSpaceRulesFormSchema = ({ intl }: BuildSpaceRulesSchemaArgs) =>
  z.object({
    rules: z.string().min(
      100,
      intl.formatMessage({
        id: "hosting.space_rules.rules_required",
        defaultMessage: "Please enter at least 100 characters",
      }),
    ),
    minAge: z.string(),
  });

type SpaceRulesFormValues = z.infer<
  ReturnType<typeof buildSpaceRulesFormSchema>
>;

export { buildSpaceRulesFormSchema };
export type { SpaceRulesFormValues };
